<template>
  <div class="address" @click="show = true">
    <el-autocomplete :disabled="disabled" style="width: 100%" class="inline-input" value-key="name" v-model="searchKey"
      :fetch-suggestions="fetchSuggestions" placeholder="请输入内容" :clearable="true" @clear="clearText"
      @select="handleChoose">
      <template slot="prepend">{{ scope }}</template>

      <el-button slot="append" icon="el-icon-map-location" @click="showMap"><span v-if="isOnWay && price"
          class="red">+{{
            price }}</span>
        <span class="red" v-if="!isOnWay">不顺路</span>
      </el-button>
    </el-autocomplete>

    <el-dialog :title="recPointDialogTitle" :visible.sync="recPointVisible" width="480px" append-to-body
      :close-on-click-modal="false" @close="handleRecPointCancel">
      <div class="rec-point-picker" v-if="conditionArea">
        <div class="rec-point-tip" v-if="conditionArea.recommendReason">
          {{ conditionArea.recommendReason }}
        </div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>
            <a href="javascript:;" @click="resetRecPointLevel">全部</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, index) in recPointPath" :key="item.id">
            <a href="javascript:;" @click="backToRecPointLevel(index)">{{ item.name }}</a>
          </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="rec-point-list">
          <div class="rec-point-item" v-for="item in currentRecPoints" :key="item.id"
            @click="handleRecPointClick(item)">
            <span class="rec-point-name">{{ item.name }}</span>
            <i v-if="hasNextRecPoints(item)" class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRecommendAddress, getUpPrice, getPathAreas, searchPlace, getRecommendAddressDetail } from "@/api";
import { Message } from "element-ui";
import { SHOW_PASSENGER_MAP } from "@/core/const/global-event";

export default {
  name: "PoiSelector",
  props: {
    value: Object,
    suggest: Array,
    pathId: Number,
    ticketId: Number,
    isStart: Boolean,
    disabled: Boolean,
    modifyOrder: Object,
    orderType: Number,
    date: String
  },

  computed: {
    scope() {
      return this.areaInfo && this.areaInfo.name;
    },
    recPointDialogTitle() {
      return this.isStart ? "请选择推荐上车点" : "请选择推荐下车点";
    }
  },

  mounted() {
    this.initData();
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.searchKey = val.name;
        } else {
          this.$emit("onUpPriceGet", 0);
          this.price = null;
          this.searchKey = null;
        }
      },
      immediate: true
    },
    searchKey(val) {
      // 输入无效地址清空value
      if (this.value && val !== this.value.name) {
        this.$emit("input", null);
        this.$emit("onUpPriceGet", 0);
        this.price = null;
      }
    },
    pathId() {
      this.initData();
    },

    suggest() {
      if (this.suggest) {
        this.defaultAddress = this.suggest.map((item) => {
          return {
            name: item.address,
            lng: item.longitude,
            lat: item.latitude
          };
        });
      }
    }
  },
  data() {
    return {
      searchKey: "",
      price: "",
      show: false,
      defaultAddress: [],
      isOnWay: true,
      areaInfo: null,
      recPointVisible: false,
      conditionArea: null,
      recPointPath: [],
      currentRecPoints: [],
      pendingAddress: null
    };
  },
  methods: {
    initData() {
      if (this.pathId) {
        getPathAreas({ pathId: this.pathId }).then((res) => {
          this.areaInfo = this.isStart ? res.data[0] : res.data[1];
        });
      }
    },

    handleChoose(item) {
      this.checkConditionAreaAndChoose(item);
    },

    checkConditionAreaAndChoose(item) {
      if (!this.canCheckConditionArea()) {
        this.confirmAddress(item);
        return;
      }

      const param = {
        pathId: this.pathId,
        latitude: `${item.lat}`,
        longitude: `${item.lng}`,
        isStart: this.isStart,
        orderType: this.orderType,
        date: this.date
      };

      getRecommendAddressDetail(param).then((res) => {
        const area = res.data;
        if (area && area.recPoints && area.recPoints.length) {
          this.pendingAddress = item;
          this.openRecPointPicker(area);
        } else {
          this.confirmAddress(item);
        }
      });
    },

    canCheckConditionArea() {
      return this.pathId && this.orderType && this.date;
    },

    openRecPointPicker(area) {
      this.conditionArea = area;
      this.recPointPath = [];
      this.currentRecPoints = area.recPoints || [];
      this.recPointVisible = true;
    },

    resetRecPointLevel() {
      this.recPointPath = [];
      this.currentRecPoints = (this.conditionArea && this.conditionArea.recPoints) || [];
    },

    backToRecPointLevel(index) {
      const target = this.recPointPath[index];
      this.recPointPath = this.recPointPath.slice(0, index + 1);
      this.currentRecPoints = target.nextRecPoints || [];
    },

    hasNextRecPoints(item) {
      return item.nextRecPoints && item.nextRecPoints.length > 0;
    },

    handleRecPointClick(item) {
      if (this.hasNextRecPoints(item)) {
        this.recPointPath.push(item);
        this.currentRecPoints = item.nextRecPoints;
        return;
      }

      if (item.lat && item.lng) {
        this.confirmRecPoint(item);
        return;
      }

      Message.warning("该推荐点未配置坐标");
    },

    buildRecPointName(point) {
      // 多级推荐点只展示最后一级名称，避免输入框过长
      return point.name;
    },

    confirmRecPoint(point) {
      const address = {
        name: this.buildRecPointName(point),
        jd: `${point.lng}`,
        wd: `${point.lat}`,
        recAreaId: this.conditionArea.id,
        recPointId: point.id
      };
      this.recPointVisible = false;
      this.clearRecPointState();
      this.confirmAddress(address);
    },

    handleRecPointCancel() {
      if (this.pendingAddress && (!this.value || this.value.name !== this.searchKey)) {
        this.searchKey = (this.value && this.value.name) || "";
      }
      this.clearRecPointState();
    },

    clearRecPointState() {
      this.pendingAddress = null;
      this.conditionArea = null;
      this.recPointPath = [];
      this.currentRecPoints = [];
    },

    confirmAddress(item) {
      const name = item.name.replace("🍉", "");
      this.$emit("input", {
        name,
        jd: `${item.lng || item.jd}`,
        wd: `${item.lat || item.wd}`,
        recAreaId: item.recAreaId,
        recPointId: item.recPointId
      });
      this.searchKey = name;

      const param = {
        pathId: this.pathId,
        longitude: item.lng || item.jd,
        latitude: item.lat || item.wd,
        isStart: this.isStart
      };
      getUpPrice(param).then((res) => {
        this.price = res.data;
        this.$emit("onUpPriceGet", res.data);
      });
    },

    fetchSuggestions(val, cb) {
      if (!this.pathId) {
        cb([]);
        Message.error("请先选择路线");
        return;
      }
      if (!this.ticketId) {
        cb([]);
        Message.error("请先选择时间");
        return;
      }

      if (val) {
        searchPlace(this.areaInfo.id, val).then((res) => {
          if (res.data && res.data.length) {
            cb(res.data);
          } else {
            cb([]);
          }
        });
      } else {
        const df = this.defaultAddress || [];
        getRecommendAddress({
          areaId: this.areaInfo.id,
          type: 1
        }).then((res) => {
          cb(df.concat(this.transRecommendData(res.data)));
        });
      }
    },
    showMap() {
      if (this.value && this.value.jd) {
        const { orderStatus, driverId, ticketId } = this.modifyOrder || {};
        const order = {
          pathId: this.pathId,
          lng: this.value.jd,
          lat: this.value.wd,
          address: this.value.name,
          orderStatus,
          driverId,
          ticketId
        };
        const param = {
          type: 2,
          order: order,
          recommendAddressParam: this.recommendAddressParam,
          isStart: this.isStart,
          chooseCb: this.handleChoose
        };
        this.$bus.$emit(SHOW_PASSENGER_MAP, param);
      }
    },

    transRecommendData(data = []) {
      const list = [];
      data.forEach((item) => {
        list.push({
          name: `${item.name}`,
          lng: `${item.longitude}`,
          lat: `${item.latitude}`
        });
      });
      return list;
    },

    clearText() {
      this.searchKey = "";
    },

    setIsOnWay(val, param) {
      this.isOnWay = val;
      this.recommendAddressParam = param;
    }
  }
};
</script>

<style lang="less" scoped>
.rec-point-picker {
  .rec-point-tip {
    margin-bottom: 12px;
    color: #e6a23c;
    line-height: 1.5;
  }

  .rec-point-list {
    margin-top: 16px;
    max-height: 360px;
    overflow-y: auto;
  }

  .rec-point-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: #409eff;
      background: #f5f9ff;
    }
  }

  .rec-point-name {
    color: #303133;
    font-size: 14px;
  }
}

.red {
  color: #f56c6c;
}
</style>
